var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "17px",
    viewBox: "0 0 86 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setup-1",
    transform: "translate(-59.000000, -444.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wellen",
    transform: "translate(20.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7465054,54.457054 C54.8285212,54.457054 54.9111931,54.4563949 54.993209,54.4550767 C60.7251309,54.3944435 66.1342384,52.2347088 70.2232193,48.3746034 C76.6585088,42.0621416 87.5784235,41.9171485 94.0137131,48.2296106 C98.0580772,52.1220099 103.395011,54.2619726 109.051478,54.2619726 L109.148585,54.2619726 C114.845076,54.2369285 120.204318,52.044241 124.23884,48.0865949 C125.235496,47.1092112 125.256493,45.5030857 124.284769,44.4999987 C123.314358,43.4962528 121.718658,43.4758219 120.722002,44.4532055 C114.348388,50.7050342 103.929098,50.7544636 97.4957767,44.5619503 C89.1216333,36.3481046 75.1507298,36.4594854 66.7765864,44.6739901 C63.6101194,47.6628203 59.4069726,49.3355106 54.9400628,49.3829628 C50.4587182,49.428438 46.315935,47.8150628 43.2780689,44.8348004 C42.2814126,43.8574166 40.6863688,43.8778475 39.7153014,44.8809346 C38.7442341,45.8846806 38.7645741,47.4908061 39.7612304,48.4681898 C43.703895,52.3355447 49.0172081,54.457054 54.7465054,54.457054 Z",
    id: "Path",
    transform: "translate(82.000160, 46.457054) scale(1, -1) translate(-82.000160, -46.457054) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrail);
export default __webpack_public_path__ + "static/media/trail.3dac532af4395bf99fa9c8b5fdb2cce0.svg";
export { ForwardRef as ReactComponent };